<script>
  export default {
    name: 'error-displayer',
    methods: {
      error(row, errors) {
        let error = errors.find(error => error.field == row)
        return error
      },
      errorMessageFor(row, errors) {
        let error = this.error(row, errors)
        if(error)
         return error.msg[0]
      },
    }
  }
</script>
